// KL strona glowna D + sekcje kolekcji (07.10.2026): koszyk boczny z animacja, zakladki, kropki aranzacji,
// serduszko Swym na kartach klh-p, formularz "Dobierz zarowke".
// 08.10.2026 perf fix: ladowany tylko na index i collection; ikony mega menu przeniesione do kl-global.js.
import { CartAddEvent } from '@theme/events';

const KOSZYK_IKONA = 'cart-icon, .header-actions__cart-icon, a[href$="/cart"]';

function lot(img, cel) {
  // miniatura zdjecia leci do ikony koszyka w naglowku
  if (!img || !cel || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const a = img.getBoundingClientRect(), b = cel.getBoundingClientRect();
  if (!a.width || !b.width) return;
  const k = img.cloneNode();
  k.removeAttribute('srcset');
  k.className = 'klh-lot';
  Object.assign(k.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
  document.body.appendChild(k);
  const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
  k.animate([
    { transform: 'translate(0,0) scale(1)', opacity: 1 },
    { transform: `translate(${dx}px,${dy}px) scale(0.08)`, opacity: 0.6 }
  ], { duration: 650, easing: 'cubic-bezier(.5,0,.75,0)' }).finished.then(() => {
    k.remove();
    cel.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 350 });
  });
}

document.addEventListener('submit', async (e) => {
  const form = e.target.closest && e.target.closest('form[data-klh-dod]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('button[type="submit"]');
  if (btn.classList.contains('is-laduje')) return;
  btn.classList.add('is-laduje');
  btn.disabled = true;
  const karta = form.closest('.klh-p');
  const img = karta && karta.querySelector('.klh-p__f1');
  lot(img, document.querySelector(KOSZYK_IKONA));
  const sekcje = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const fd = new FormData(form);
  if (sekcje.length) fd.append('sections', sekcje.join(','));
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    const j = await r.json();
    if (j.status) throw new Error(j.description || j.message);
    document.dispatchEvent(new CartAddEvent({}, form.id || 'klh', {
      source: 'klh-karta', itemCount: Number(fd.get('quantity')) || 1, productId: String(j.product_id || ''),
      variantId: String(fd.get('id')), sections: j.sections
    }));
    btn.classList.remove('is-laduje');
    btn.classList.add('is-dodano');
    setTimeout(() => btn.classList.remove('is-dodano'), 2200);
  } catch (err) {
    btn.classList.remove('is-laduje');
    btn.classList.add('is-blad');
    btn.title = String(err.message || 'Nie udało się dodać do koszyka');
    setTimeout(() => btn.classList.remove('is-blad'), 3000);
  } finally {
    btn.disabled = false;
  }
}, true);

// hero: obraz "Dzien" ma srcset w data-* (pobierany dopiero na zadanie)
function dzienLaduj(hero) {
  const d = hero && hero.querySelector('.klh-hero__dzien');
  if (d && d.dataset.srcset) {
    d.sizes = d.dataset.sizes || '';
    d.srcset = d.dataset.srcset;
    if (d.dataset.src) d.src = d.dataset.src;
    delete d.dataset.srcset;
  }
  return d;
}
document.addEventListener('pointerover', (e) => { const b = e.target.closest && e.target.closest('[data-klh-pora="dzien"]'); if (b) dzienLaduj(b.closest('.klh-hero')); }, { passive: true });
document.addEventListener('focusin', (e) => { const b = e.target.closest && e.target.closest('[data-klh-pora="dzien"]'); if (b) dzienLaduj(b.closest('.klh-hero')); });

// serduszko: lista Swym (Wishlist Plus), ten sam zapis co na karcie produktu (kl-f.js)
function zapisane() { try { return JSON.parse(localStorage.getItem('klFSerce') || '[]'); } catch (e) { return []; } }
function oznacz(s) { s.classList.add('on'); s.setAttribute('aria-pressed', 'true'); }

document.addEventListener('click', (e) => {
  const t = e.target.closest ? e.target : null;
  if (!t) return;

  const serce = t.closest('[data-klh-serce]');
  if (serce) {
    e.preventDefault();
    const p = { epi: Number(serce.dataset.epi), empi: Number(serce.dataset.empi), du: serce.dataset.du, iu: serce.dataset.iu, pr: Number(serce.dataset.pr) };
    oznacz(serce);
    const l = zapisane();
    if (!l.includes(p.empi)) { l.push(p.empi); try { localStorage.setItem('klFSerce', JSON.stringify(l)); } catch (er) {} }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push((swat) => {
      try {
        if (swat.api && swat.api.addToWishList) swat.api.addToWishList(p, () => {}, () => {});
        else if (swat.addToWishList) swat.addToWishList(p, () => {});
      } catch (er) {}
    });
    return;
  }

  const pora = t.closest('[data-klh-pora]');
  if (pora) {
    const hero = pora.closest('.klh-hero');
    const dzien = pora.dataset.klhPora === 'dzien';
    hero.querySelectorAll('[data-klh-pora]').forEach((b) => { const on = b === pora; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    if (!dzien) { hero.classList.remove('is-dzien'); return; }
    // obraz "Dzien" nie jest pobierany przy wejsciu na strone (perf 08.10.2026) - laduje sie przy pierwszym
    // najechaniu / kliknieciu; plynne przejscie dopiero, gdy zdjecie jest gotowe (max 6 s czekania)
    const d = dzienLaduj(hero);
    const ustaw = () => { if (hero.querySelector('[data-klh-pora="dzien"]').getAttribute('aria-pressed') === 'true') hero.classList.add('is-dzien'); };
    if (!d || (d.complete && d.naturalWidth > 1)) { ustaw(); return; }
    Promise.race([
      new Promise((r) => { d.addEventListener('load', r, { once: true }); d.addEventListener('error', r, { once: true }); }),
      new Promise((r) => setTimeout(r, 6000))
    ]).then(ustaw);
    return;
  }

  const tab = t.closest('[data-klh-tab]');
  if (tab) {
    const box = tab.closest('[data-klh-zakladki]');
    box.querySelectorAll('[data-klh-tab]').forEach((b) => { const on = b === tab; b.classList.toggle('on', on); b.setAttribute('aria-selected', on); });
    box.querySelectorAll('[data-klh-panel]').forEach((p) => { p.hidden = p.dataset.klhPanel !== tab.dataset.klhTab; if (!p.hidden) p.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; }); });
    return;
  }

  const dot = t.closest('[data-klh-dot]');
  document.querySelectorAll('.klh-dot.on').forEach((d) => { if (!dot || d !== dot.parentElement) { d.classList.remove('on'); d.querySelector('[data-klh-dot]').setAttribute('aria-expanded', 'false'); } });
  if (dot) {
    const d = dot.parentElement, on = !d.classList.contains('on');
    d.classList.toggle('on', on);
    dot.setAttribute('aria-expanded', on);
  }
});

// formularz zarowki: filtry metapol kolekcji Zrodla swiatla, przekierowanie dopiero po przycisku
const KL_MOC = [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 18, 20, 22, 23, 24, 30, 36, 40, 42, 50, 60];
document.addEventListener('submit', (e) => {
  const f = e.target.closest && e.target.closest('form[data-klh-zarowka]');
  if (!f) return;
  e.preventDefault();
  const w = (n) => (f.querySelector(`input[name="${n}"]:checked`) || {}).value || '';
  const q = new URLSearchParams();
  // 04.11.2026: gwint prowadzi do kolekcji trzonka (data-kol: e27, e14, gu10, g9, e40, tuba-led-t8 - te same co kafle trzonkow w menu),
  // barwa i moc zostaja filtrami; bez data-kol (stary kod HTML) - filtr typ_zrodla_swiatla na kolekcji Zrodla swiatla jak dotad
  const gEl = f.querySelector('input[name="g"]:checked');
  const kol = gEl && gEl.dataset.kol ? gEl.dataset.kol : '';
  if (w('g') && !kol) q.append('filter.p.m.custom.typ_zrodla_swiatla', w('g'));
  if (w('b')) q.append('filter.p.m.custom.temperatura_barwowa', w('b'));
  if (w('m')) {
    const [od, doo] = w('m').split('-').map(Number);
    KL_MOC.filter((x) => x >= od && x <= doo).forEach((x) => q.append('filter.p.m.custom.max_moc_w', x));
  }
  location.href = (kol ? '/collections/' + kol : f.action) + (q.toString() ? '?' + q.toString() : '');
});

// kropki aranzacji: wspolrzedne podane w % zdjecia, zdjecie przyciete object-fit: cover do kadru sekcji
function kropki() {
  document.querySelectorAll('.klh-look[data-klh-proporcja]').forEach((box) => {
    if (box.hidden) return;
    const [w, h] = box.dataset.klhProporcja.split('/').map(Number), r = w / h;
    const bw = box.clientWidth, bh = box.clientHeight;
    if (!bw || !bh) return;
    const s = Math.max(bw / w, bh / h), iw = w * s, ih = h * s, ox = (iw - bw) / 2, oy = (ih - bh) * (Number(box.dataset.klhFy || 50) / 100);
    box.querySelectorAll('.klh-dot[data-x]').forEach((d) => {
      const x = (Number(d.dataset.x) / 100) * iw - ox, y = (Number(d.dataset.y) / 100) * ih - oy;
      d.style.left = Math.min(Math.max(x, 24), bw - 24) + 'px';
      d.style.top = Math.min(Math.max(y, 24), bh - 24) + 'px';
    });
  });
}
window.addEventListener('resize', kropki);
document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('[data-klh-tab^="pok-"]')) requestAnimationFrame(kropki); });

function start() {
  kropki();
  const l = zapisane();
  document.querySelectorAll('[data-klh-serce]').forEach((s) => { if (l.includes(Number(s.dataset.empi))) oznacz(s); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
